import React, {useEffect, useState} from "react";
import {
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneGridTypeItems,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoCardInfoTypeOneStatusTypes,
    RaikoChipTypes,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {MawakibService} from "../../../serverService/mawakibService/MawakibService";
import RaikoDrawer, {RaikoDrawerDirection} from "../../../raikoComponents/raikoDrawer/RaikoDrawer.tsx";
import MawakibRegisterItemDetail from "../../../component/mawakibRegisterItemDetail/MawakibRegisterItemDetail";
import {useDebounce} from "@uidotdev/usehooks";
import {css} from "@emotion/css";

export default function MawakibRegisterList({mawakibId}) {

    let page = 0
    const size = 15

    const service = new MawakibService()

    const [mawakibRegisteredList, setMawakibRegisteredList] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoadingState, setTableLoadingState] = useState(false);

    const [numberOfItems, setNumberOfItems] = useState(0);

    const [mawakibRegisterId, setMawakibRegisterId] = useState(-1);

    const [titleSearch, setTitleSearch] = useState("");
    const _titleSearch = useDebounce(titleSearch, 500);

    const [statusFilter, setStatusFilter] = useState(mawakibtStatus.ALL.id)

    useEffect(() => {
        if (typeof mawakibId !== 'undefined') {
            getRegisteredListFromServer()
        }
    }, [mawakibId, _titleSearch, statusFilter]);

    function getRegisteredListFromServer(status = statusFilter) {
        setTableLoadingState(true)
        service.getMawakibRegisteredList(mawakibId, page, size, _titleSearch, status)
            .then(response => {
                setPageCount(response.totalPage)
                setMawakibRegisteredList([])
                setNumberOfItems(response.numberOfItems)
                response.data.map((item, index) => {
                    setMawakibRegisteredList(prevState => [
                        ...prevState,
                        registerTableRow(
                            (page * size) + index + 1,
                            item.id,
                            item.name,
                            item.managerFirstName,
                            item.managerLastName,
                            item.managerPhoneNumber,
                            item.managerNationalCode,
                            item.city,
                            item.sendAt,
                            item.status
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoadingState(false)
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getRegisteredListFromServer()
    }

//
    const [openDrawer, setOpenDrawer] = useState(false)

    function handleOpenDrawer() {
        setOpenDrawer(true)
    }

    function handleCloseDrawer() {
        setOpenDrawer(false)
        setMawakibRegisterId(-1)
    }

    //


    function handleShowMawakibRegisterItemDetail(id) {
        setMawakibRegisterId(id)
        setOpenDrawer(true)
    }

    function handleUpdateTable(id, newStatus) {
        const _newItems = []

        mawakibRegisteredList.map((item, index) => {
            if (item.id === id) {
                _newItems.push({
                    ...item,
                    status: newStatus === mawakibtStatus.ACCEPTED.id ?
                        <RaikoCustomSimpleChip title={mawakibtStatus.ACCEPTED.name} type={RaikoChipTypes.success}/> :
                        newStatus === mawakibtStatus.REJECTED.id ?
                            <RaikoCustomSimpleChip title={mawakibtStatus.REJECTED.name} type={RaikoChipTypes.error}/> :
                            <RaikoCustomSimpleChip title={mawakibtStatus.AWAITING_FOR_REVIEW.name}
                                                   type={RaikoChipTypes.warning}/>

                })
            } else {
                _newItems.push(item)
            }
        })
        setMawakibRegisteredList(_newItems)
    }

    function handleDeleteAllFilter() {
        setStatusFilter(mawakibtStatus.ALL.id)
    }

    const [selectDisplayType, setSelectDisplayType] = useState(false);
    return (
        <>
            <RaikoDrawer
                openDrawer={openDrawer}
                onClose={handleCloseDrawer}
                onOpen={handleOpenDrawer}
                anchor={RaikoDrawerDirection.BOTTOM}
                containerId={"basePageContainer"}
            >
                <MawakibRegisterItemDetail
                    id={mawakibRegisterId}
                    handleCloseDrawer={handleCloseDrawer}
                    handleUpdateTable={handleUpdateTable}/>
            </RaikoDrawer>
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"مواکب ثبت نام شده"}
                            amount={numberOfItems}
                            hasSelectDisplayType
                            selectDisplayType={selectDisplayType}
                            setSelectDisplayType={setSelectDisplayType}
                        />
                        <RaikoTableSearchContainer
                            value={titleSearch}
                            setValue={setTitleSearch}
                            labelText={"نام موکب"}
                            hasFilter
                            handleDeleteAllFilters={handleDeleteAllFilter}
                            filterStatus={statusFilter.length > 0 && mawakibtStatus.ALL.id !== statusFilter}
                        >
                            <RaikoCustomSelect
                                labelText={"وضعیت"}
                                value={statusFilter}
                                setValue={setStatusFilter}
                                items={[
                                    raikoCustomSelectItemGenerator(mawakibtStatus.ALL.id, mawakibtStatus.ALL.name),
                                    raikoCustomSelectItemGenerator(mawakibtStatus.ACCEPTED.id, mawakibtStatus.ACCEPTED.name),
                                    raikoCustomSelectItemGenerator(mawakibtStatus.REJECTED.id, mawakibtStatus.REJECTED.name),
                                    raikoCustomSelectItemGenerator(mawakibtStatus.AWAITING_FOR_REVIEW.id, mawakibtStatus.AWAITING_FOR_REVIEW.name),
                                ]}
                            />

                        </RaikoTableSearchContainer>
                        <RaikoCustomTable
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            isLoading={tableLoadingState}
                            data={mawakibRegisteredList}
                            header={mawakibRegisterHeader}
                            rowClicked={handleShowMawakibRegisterItemDetail}
                            selectDisplayType={selectDisplayType}
                        >
                            <RaikoGridThreeColumn className={css`padding: 3px`}>
                                {
                                    mawakibRegisteredList.map((item, index) => {
                                        return <RaikoCardInfoTypeOne
                                            key={index}
                                            title={item.name}
                                            titleLabel={`${item.managerFirstName} ${item.managerLastName}`}
                                            items={[
                                                RaikoCardInfoTypeOneItemGenerator("شماره همراه", item.managerPhoneNumber),
                                                RaikoCardInfoTypeOneItemGenerator("کد ملی", item.managerNationalCode),
                                                RaikoCardInfoTypeOneItemGenerator("شهر", item.city),
                                                RaikoCardInfoTypeOneItemGenerator("تاریخ ثبت", item.sendAt),
                                            ]}
                                            status
                                            statusType={
                                                item.statusPlace === mawakibtStatus.ACCEPTED.id ?
                                                    RaikoCardInfoTypeOneStatusTypes.SUCCESS :
                                                    item.statusPlace === mawakibtStatus.REJECTED.id ? RaikoCardInfoTypeOneStatusTypes.ERROR :
                                                        RaikoCardInfoTypeOneStatusTypes.WARNING
                                            }
                                            statusText={
                                                item.statusPlace === mawakibtStatus.ACCEPTED.id ?
                                                    mawakibtStatus.ACCEPTED.name :
                                                    item.statusPlace === mawakibtStatus.REJECTED.id ? mawakibtStatus.REJECTED.name :
                                                        mawakibtStatus.AWAITING_FOR_REVIEW.name
                                            }
                                            gridTypeItems={RaikoCardInfoTypeOneGridTypeItems.TWO_COLUMN}
                                            onClick={_=>{
                                                handleShowMawakibRegisterItemDetail(item.id)
                                            }}
                                        />
                                    })
                                }
                            </RaikoGridThreeColumn>
                        </RaikoCustomTable>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </>
    )
}


function registerTableRow(number, id, name, managerFirstName, managerLastName, managerPhoneNumber, managerNationalCode, city, sendAt, status) {
    return {
        number,
        id,
        name,
        managerFirstName,
        managerLastName,
        managerPhoneNumber,
        managerNationalCode,
        city,
        sendAt: convertUniversalDateToPersianDate(sendAt),
        status: status === mawakibtStatus.ACCEPTED.id ?
            <RaikoCustomSimpleChip title={mawakibtStatus.ACCEPTED.name} type={RaikoChipTypes.success}/> :
            status === mawakibtStatus.REJECTED.id ?
                <RaikoCustomSimpleChip title={mawakibtStatus.REJECTED.name} type={RaikoChipTypes.error}/> :
                <RaikoCustomSimpleChip title={mawakibtStatus.AWAITING_FOR_REVIEW.name} type={RaikoChipTypes.warning}/>,
        statusPlace: status,

    }

}

export const mawakibtStatus = {
    ALL: {
        id: "ALL",
        name: "همه"
    }, ACCEPTED: {
        id: "ACCEPTED",
        name: "پذیرفته شده"
    }, REJECTED: {
        id: "REJECTED",
        name: "رد شده"
    }, AWAITING_FOR_REVIEW: {
        id: "AWAITING_FOR_REVIEW",
        name: "در حال بررسی"
    },
}

const mawakibRegisterHeader = [
    {
        id: "number",
        label: "#",
    }, {
        id: "name",
        label: "نام موکب",
    }, {
        id: "managerFirstName",
        label: "نام",
    }, {
        id: "managerLastName",
        label: "نام خانوادگی",
    }, {
        id: "managerPhoneNumber",
        label: "شماره همراه",
    }, {
        id: "managerNationalCode",
        label: "کد ملی",
    },
    {
        id: "city",
        label: "شهر",
    },
    {
        id: "sendAt",
        label: "تاریخ ثبت",
    },
    {
        id: "status",
        label: "وضعیت",
    },
]